/**
 * VendorFlagService
 * Service for managing vendor flags
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor flag CRUD operations
 */
export class VendorFlagService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorFlagService.DEFAULT_SERVICE_PATH,
            basePath: VendorFlagService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorFlagService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorFlagService.BASE_PATH = 'api/vendor-flags';
//# sourceMappingURL=VendorFlagService.js.map